<div class="geo-code-wrapper clearfix" id="'Q_'{{question?.UniqueNumber}}_telephone" *ngIf="isLoadControl">
  <div class="custom-select-wrapper geo-code-dropdown" [ngClass]="{readonly : question.IsDisabled}">
    <div *ngIf="selectedCountryData.CountryCode == 0" class="geo-code-val"></div>
    <div *ngIf="selectedCountryData.CountryCode != 0" class="geo-code-val">+{{selectedCountryData.CountryCode}}</div>
    <select (change)="dropDownSelectedValue($event)" [(ngModel)]="question.SelectedCountry"
      class="geo-code-select" aria-label="Select Country Code">
      <option *ngFor="let CountryData of CountryDatas" [value]="CountryData.Country">
        +{{CountryData.CountryCode}}
      </option>
    </select>
  </div>
  <div class="geo-code-input">
    <input type="text" [disabled]="question?.isOtherAnswer" class="ansopt-textbox" [ngClass]="{'red-zone':question?.isValid}"
      id="{{question?.UniqueNumber}}_txt_phone" placeholder="{{selectedCountryData?.PlaceholderNumber}}"
      [attr.name]="'Q_'+question?.UniqueNumber+'_Phone_NAME'" [(ngModel)]="question.otherAnswer" onPaste="return false"
      (focus)="onFocus($event)" (blur)="onBlurMethod($event.target.value)" maxlength="{{selectedCountryData?.TextLength}}">
  </div>
</div>
